import { Fragment, useContext } from 'react';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import { KeyAvatar } from '../../recoverPassword/components';
import { InputV2 } from '../../subComponents/input';
import { ButtonV2 } from '../../subComponents/button';
import { ChangePasswordContext } from '../../../contexts/changePassword';

const InputTypeCollection = new Map([
  [true, 'text'],
  [false, 'password'],
]);

const IconCollection = new Map([
  [true, <Visibility fontSize='small' />],
  [false, <VisibilityOff fontSize='small' />],
]);

/**
 * 
 * @param {{
 *  name: string;
 *  hide: boolean;
 *  value: boolean;
 * }} param 
 */
const EyeAdornment = ({
  name,
  hide,
  value,
}) => {
  const { handleChangeVisibility } = useContext(ChangePasswordContext);

  if (hide) {
    return <Fragment />;
  }

  return (
    <InputAdornment position='end'>
      <IconButton
        aria-label='toggle password visibility'
        size='small'
        onClick={handleChangeVisibility.bind(this, {
          target: { name, value: !value },
        })}
      >
        {IconCollection.get(value)}
      </IconButton>
    </InputAdornment>
  );
};

export const ChangePasswordForm = () => {
  const { field, error, visibility, changePasswordAPI: api, handleChange, handleSubmit, handleChangeVisibility } =
   useContext(ChangePasswordContext);

  return (
    <div className="flex flex-column justify-content-center gap-16 width-360 height-460">
      <div className="flex align-items-center justify-content-center">
        <KeyAvatar />
      </div>

      <form className="flex flex-column gap-20" onSubmit={handleSubmit}>
        <InputV2
          variant="outlined"
          margin="normal"
          required
          fullWidth
          id="currentPassword"
          label="Current Password"
          name="currentPassword"
          type={InputTypeCollection.get(visibility.currentPassword)}
          autoComplete="off"
          autoFocus
          value={field.currentPassword}
          onChange={handleChange}
          InputProps={{
            endAdornment: (
              <EyeAdornment
                name='currentPassword'
                value={visibility.currentPassword}
              />
            )
          }}
        />

        <InputV2
          variant="outlined"
          margin="normal"
          required
          fullWidth
          id="newPassword"
          label="New Password"
          name="newPassword"
          type={InputTypeCollection.get(visibility.newPassword)}
          autoComplete="off"
          value={field.newPassword}
          onChange={handleChange}
          InputProps={{
            endAdornment: (
              <EyeAdornment
                name='newPassword'
                value={visibility.newPassword}
                hide
              />
            ),
          }}
        />

        <InputV2
          variant="outlined"
          margin="normal"
          required
          fullWidth
          id="confirmPassword"
          label="Confirm Password"
          name="confirmPassword"
          type={InputTypeCollection.get(visibility.confirmPassword)}
          autoComplete="off"
          value={field.confirmPassword}
          onChange={handleChange}
          InputProps={{
            endAdornment: (
              <EyeAdornment
                name='confirmPassword'
                value={visibility.confirmPassword}
                hide
              />
            )
          }}
        />

        <ButtonV2
          type="submit"
          label="Change Password"
          id="changePasswordButton"
          loading={api.loading}
          disabled={error.has || api.loading}
        />
      </form>
    </div>
  );
}

export default ChangePasswordForm;
